import type { Components } from "react-markdown";

import { colorsPalettes } from "@similarweb/styles";
import { Text } from "@similarweb/ui-components/foundations";

import { StyledText } from "app/pages/sales-intelligence/modules/ai-agent/components/markdown-components";
import AIAgentTrackingService from "app/pages/sales-intelligence/modules/ai-agent/services/tracking/trackingService";
import { getBaseMarkdownComponents } from "app/pages/sales-intelligence/modules/ai-agent/utils/markdownComponents";

import { StyledLi, StyledLink, StyledTable, StyledTd, StyledTh } from "../components/SuperAgentMessage/styles";

export const getSuperAgentMarkdownComponents: (props: Record<string, unknown>) => Components = (props) => ({
    ...getBaseMarkdownComponents(props),
    h1: ({ children }) => (
        <Text
            fontVariant="h4"
            display="block"
            color={colorsPalettes.carbon[500]}
            margin="0 0 24px"
        >
            {children}
        </Text>
    ),
    h2: ({ children }) => (
        <Text
            fontVariant="h5"
            display="block"
            color={colorsPalettes.carbon[500]}
            margin="0 0 16px"
        >
            {children}
        </Text>
    ),
    h3: ({ children }) => (
        <Text
            fontVariant="h6"
            display="block"
            color={colorsPalettes.carbon[500]}
            margin="0 0 8px"
        >
            {children}
        </Text>
    ),
    p: ({ children }) => (
        <StyledText
            fontVariant="body2"
            display="block"
            margin="0 0 24px"
            color={colorsPalettes.carbon[500]}
        >
            {children}
        </StyledText>
    ),
    li: ({ children }) => <StyledLi>{children}</StyledLi>,
    a: (props) => (
        <StyledLink
            {...props}
            target="_blank"
            onMouseDown={() => {
                AIAgentTrackingService.superAgent.trackLinkClick(props.href, "inline link");
            }}
        />
    ),
    table: ({ children }) => <StyledTable data-automation="super-agent-table">{children}</StyledTable>,
    th: ({ children }) => <StyledTh>{children}</StyledTh>,
    td: ({ children }) => <StyledTd>{children}</StyledTd>,
});
